export enum AdlAnswerTypeEnum {
    Yes = 1,
    Occasionally = 2,
    No = 3,
}
